import { type ReactNode } from "react";
import { useAuth } from "react-oidc-context";
import { registerAuthTokenGetter } from "./authToken";

export function AuthTokenBridge({ children }: { children: ReactNode }) {
  const auth = useAuth();

  registerAuthTokenGetter(async () => auth.user?.access_token ?? null);

  return <>{children}</>;
}
